export const validation = {
  password: "Password is required",
  email: "Email is required",
  fullName: "Full name is required",
  validEmail: "Please enter valid email address",
  validPassword: "Password Must be 6 to 15 Characters",
  firstName: "First name is required",
  lastName: "Last name is required",
  middleName: "Middle name is required",
  phoneNumber: "Phone number is required",
  validPhoneNumber: "Please enter valid phone number",
  phoneNumberShort: "Phone number must not be less than 6 digits",
  phoneNumberLong: "Phone number must not be more than 15 digits",
  address: "Address is required",
  city: "City Name is required",
  state: "State is required",
  zipCode: "Zip Code is required",
  passwordField:
    "Password should be atleast 6 to 15 character,\nOne Uppercase, One Lowercase,\nOne Number & special Character Example Special characters must be use @, #, $, %, ^, &, +, !, =",
  confirmPasswordField: "Password and Confirm Password must be the same",
  confirmPassword: "Confirm password is required",
  countryId: "Country is required",
  country: "Country is reqiured",
  countryCode: "Country code is required",
  phoneCode: "Phone code is required",
};
